import React from 'react'

const Loader: React.FC = () => {
	return (
		<div className='fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-80 z-50'>
			<div className='flex flex-col items-center space-y-4'>
				<div className='w-16 h-16 border-4 border-t-4 border-red-600 border-solid rounded-full animate-spin border-t-transparent'></div>
				<span className='text-white text-xl font-semibold animate-pulse'>
					Loading...
				</span>
			</div>
		</div>
	)
}

export default Loader
